import { makeStyles } from '@mui/styles';
const datePickerStyles = makeStyles(({ transitions, palette, breakpoints }) => ({
    root: {
        background: palette.common.white,
        paddingRight: 0,
    },
    fieldWrapper: {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        [breakpoints.down('sm')]: {
            gridTemplateColumns: 'repeat(12, 1fr)',
        },
    },
    input: {
        width: '100%',
        transition: transitions.create(['border-color', 'box-shadow']),
        '& input': {
            width: '100%',
            padding: '4px 4px 4px 8px',
            height: 'fit-content',
        },
        [breakpoints.down('sm')]: {
            gridColumn: '6/-1',
        },
    },
    errorText: {
        fontSize: 'inherit',
    },
    notchedOutline: {
        borderRadius: 0,
        borderWidth: 1,
        '& span': {
            display: 'none',
        },
    },
    focused: {
        borderColor: palette.primary.main,
    },
    inputError: {
        borderColor: palette.error.main,
    },
    dateCalendar: {
        '& span': {
            color: palette.primary.main,
        },
        [breakpoints.down('sm')]: {
            padding: '0 10px 0 0',
        },
    },
    helperTextError: {},
    label: {
        // TODO fix guidance linting error forbidden-style-keys
        // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
        fontFamily: ['Swiss-BT', 'Roboto-Condensed', 'sans-serif'].join(','),
        color: palette.text.primary,
        position: 'relative',
        transform: 'unset',
        left: 'unset',
        top: 'unset',
        transformOrigin: 'unset',
        marginBottom: 0,
    },
    inputNoLabel: {},
    tooltipIconButton: {},
    labelContainer: {
        alignItems: 'center',
        [breakpoints.down('sm')]: {
            gridColumn: '1/5',
        },
    },
}), { name: 'Common_DatePicker' });
export default datePickerStyles;
//# sourceMappingURL=datePicker.styles.js.map